import React, { useContext } from 'react';
import parse, {
	DOMNode,
	domToReact,
	Element,
	HTMLReactParserOptions,
} from 'html-react-parser';
import Tooltip from '../tooltip';
import Icon from '../icon';
import Button from '../button';
import { enrollmentContext } from '../../context/enrollment/enrollment-context';
import Link from '../link';
import { PhoneSize } from '../phone/iphonecall';
import PhoneText from '../phone/PhoneText';
export interface RichTextProps {
	html: string;
	position?: string;
}

export const RichText = ({ html, position }: RichTextProps) => {
	const enrollmentCtxt = useContext(enrollmentContext);
	const dataComponent = (domNode: Element) => {
		const className = domNode?.attribs['data-class'];
		const elementPosition = domNode?.attribs['data-position'] || position;
		switch (domNode?.attribs['data-component']) {
			case 'servicedisclaimer':
				const serviceDisclaimerName = domNode?.attribs['service'];
				enrollmentCtxt.addServiceDisclaimer(serviceDisclaimerName);
				return domNode;
			case 'tooltip':
				return (
					<Tooltip
						className={className}
						icon={
							domNode?.attribs['data-icon'] &&
							parse(domNode?.attribs['data-icon'])
						}
						title={domNode?.attribs['data-title']}
						modal={!!domNode?.attribs['data-modal']}
						scroll={!!domNode?.attribs['data-scroll']}>
						{domToReact(domNode.children)}
					</Tooltip>
				);
			case 'icon':
				return (
					<Icon
						type={domNode.attribs['data-icon']}
						className={domNode.attribs['class']}
						viewBox={domNode?.attribs['data-viewbox']}
					/>
				);
			case 'phone':
				return (
					<PhoneText
						size={domNode.attribs['data-size'] as PhoneSize}
						phoneNumber={domNode.attribs['data-telno']}
						text={domNode.attribs['data-text']}
						className={className}
						position={elementPosition}
					/>
				);
			case 'button':
				return (
					<div className="w-4/12 m-auto mt-10">
						<Button
							label={domNode.attribs['data-label']}
							primary={domNode.attribs['data-primary'] === 'true'}
							href={domNode.attribs['data-href']}
						/>
					</div>
				);
			case 'link':
				return (
					<Link
						href={domNode.attribs['href']}
						title={domNode.attribs['data-title']}
						className={className}
						replace={!!domNode.attribs['replace']}
						target={domNode.attribs['target']}
						rel={domNode.attribs['rel']}
						position={elementPosition}>
						{domToReact(domNode.children)}
					</Link>
				);
			default:
				return null;
		}
	};
	const options: HTMLReactParserOptions = {
		replace: (domNode: DOMNode) => {
			const element = domNode as Element;
			if (element?.attribs) {
				return dataComponent(element);
			}
			return null;
		},
	};
	return (
		<>
			{html !== undefined ? (
				parse(html, options)
			) : (
				<div className="text-error text-center font-bold">
					<span>Missing Label</span>
				</div>
			)}
		</>
	);
};

export default RichText;
